var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63867 17V7C3.63867 5.89543 4.5341 5 5.63867 5H10.2245C10.4897 5 10.744 5.10536 10.9316 5.29289L12.6387 7H19.6387C20.7432 7 21.6387 7.89543 21.6387 9V17C21.6387 18.1046 20.7432 19 19.6387 19H5.63867C4.5341 19 3.63867 18.1046 3.63867 17Z",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderactiveIcon);
export default __webpack_public_path__ + "static/media/folderactiveIcon.d3ef03847e54e8760b46ba64fc2ff5eb.svg";
export { ForwardRef as ReactComponent };